import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { getDefaultMessageById, messages } from '../messages';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@atlaskit/button';
import CheckIcon from '@atlaskit/icon/glyph/check';
import { Dimensions } from '../../../components/visuals';
import { colors } from '@atlaskit/theme';
import { isHosted } from '../../../util/mac/helpers';

const ItemBody = styled.div`
  width: ${Dimensions.units(29)}px;
  border: #cccccc 1px solid;
  padding: ${Dimensions.units(1.25)}px;
  display: flex;
  flex-direction: column;
`;

const ItemTitle = styled.div`
  text-align: center;
  font-size: 16px;
  color: ${colors.B500};
  line-height: 20px;
  padding-bottom: ${Dimensions.units(2)}px;
`;

const List = styled.ul`
  padding-left: ${Dimensions.units(1.75)}px;
  line-height: 1.3;
  padding-bottom: ${Dimensions.units(2)}px;
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
`;

const getListOfMessageIds = (product, intl) => {
  const productKey = isHosted(product.productType) ? 'ondemand' : product.key;
  const lineArray = ['line1', 'line2', 'line3', 'line4'];

  const listOfMessageIds = lineArray
    .filter((lineNumber) => {
      const messageId = `mac.license.evaluation.description.${productKey}.${lineNumber}`;
      return !!intl.messages[messageId];
    })
    .map((lineNumber) => {
      return `mac.license.evaluation.description.${productKey}.${lineNumber}`;
    });

  if (listOfMessageIds.length === 0 && !isHosted(product.productType)) {
    return [
      'mac.license.evaluation.description.server.default.line1',
      'mac.license.evaluation.description.server.default.line2',
    ];
  }
  return listOfMessageIds;
};

type TrialLicenceItemProps = {
  product: any;
  setSelectedProductKey: Dispatch<SetStateAction<string | undefined | null>>;
  isSelected: boolean;
  hideDescription: boolean;
};

const TrialLicenceItem = ({
  product,
  setSelectedProductKey,
  isSelected,
  hideDescription,
}: TrialLicenceItemProps) => {
  const intl = useIntl();

  const handleClick = (selectedProduct: any) => {
    setSelectedProductKey(selectedProduct.key);
  };

  return (
    <>
      <ItemBody>
        <ItemTitle>{product.description}</ItemTitle>
        {isHosted(product.productType) && (
          <FormattedMessage {...messages.licenseEvaluationDescription} />
        )}
        {!hideDescription && (
          <List>
            {getListOfMessageIds(product, intl)?.map((messageId) => (
              <>
                <li>
                  <FormattedMessage
                    id={messageId}
                    defaultMessage={getDefaultMessageById(messageId)}
                  />
                </li>
              </>
            ))}
          </List>
        )}
        <ButtonWrapper>
          <Button
            data-cy={`evaluation-select-btn-${product.key}`}
            shouldFitContainer
            appearance="primary"
            onClick={() => handleClick(product)}
            selected={isSelected}
            isSelected={isSelected}
          >
            {isSelected ? (
              <CheckIcon size="medium" />
            ) : (
              <FormattedMessage {...messages.selectButton} />
            )}
          </Button>
        </ButtonWrapper>
      </ItemBody>
    </>
  );
};
export default TrialLicenceItem;
